import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import * as api from 'api/vendor-request';
import Loading from 'components/loading';
import { BorderWrapper } from 'components/styled-components';
import { TextArea, H3, Button } from '@blueprintjs/core';
import Pagination from 'components/pagination';
import map from 'lodash/map';
import Comment from 'components/vendor-requests/note-comment';
import ErrorWrapper from 'components/forms/components/error-wrapper';
import shortid from 'shortid';
import { fetchRequestComments } from 'actions/vendor-request';

const NotesBase = props => {
  const PER_PAGE = 5;
  const [comment, setComment] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const [notesPage, setNotesPage] = useState([]);
  const requestID = props.vendorRequestID;

  useEffect(() => {
    props.fetchRequestComments(props.vendorRequestID);
  }, []);

  useEffect(() => {
    setNotesPage(getNotesPage());
  }, [props.comments, currentPage]);

  const getNotesPage = () => {
    return props.comments.slice(
      currentPage * PER_PAGE,
      (currentPage + 1) * PER_PAGE
    );
  };

  const handlePageClick = page => {
    setCurrentPage(page);
  };

  const handleChange = e => {
    setComment(e.target.value);
    setErrorMsg('');
  };

  const handleKeyDown = e => {
    if (
      e.keyCode === 13 &&
      comment.trim().length > 0 &&
      !isSubmitting &&
      !e.shiftKey
    ) {
      handleSubmit();
    }
  };

  const handleSubmit = () => {
    setIsSubmitting(true);
    api
      .createRequestComment(requestID, comment)
      .then(res => {
        props.fetchRequestComments(requestID);
        setComment('');
        setIsSubmitting(false);
      })
      .catch(err => {
        setErrorMsg(err.response.data.message);
        setIsSubmitting(false);
      });
  };

  return (
    <BorderWrapper margin="1rem" padding="1rem">
      <H3>Notes</H3>
      {props.isFetchingComments ? (
        <Loading size={50} />
      ) : (
        map(notesPage, comment => (
          <Comment
            comment={comment}
            user={props.appUser}
            fetch={props.fetchRequestComments}
            key={shortid.generate()}
          />
        ))
      )}
      {props.comments.length > PER_PAGE && (
        <Pagination
          numRecords={props.comments.length}
          perPage={PER_PAGE}
          currentPage={currentPage}
          onPageClick={handlePageClick}
          handlePerPageChange={null}
          hidePerPage={true}
        />
      )}
      <TextArea
        fill={true}
        value={comment}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={'Add a note...'}
        maxLength={500}
        minLength={1}
      />
      <ErrorWrapper>{errorMsg}</ErrorWrapper>
      {comment.trim().length > 0 && (
        <Button
          minimal={true}
          fill={true}
          style={{ marginTop: '0.5rem' }}
          onClick={handleSubmit}
          loading={isSubmitting}
        >
          SUBMIT
        </Button>
      )}
    </BorderWrapper>
  );
};

const mapStateToProps = state => ({
  comments: state.vendorRequest.comments,
  isFetchingComments: state.vendorRequest.isFetchingComments,
  isErrorComments: state.vendorRequest.isErrorComments,
  appUser: state.auth.appUser,
});

const Notes = connect(
  mapStateToProps,
  { fetchRequestComments }
)(NotesBase);

export default Notes;
